<template>
  <div class="profile-component">
    <VeeForm ref="form" class="profile-form" @submit="onSaveQuit">
      <section>
        <IconLabel heavy no-padding :label="$t('ETAB.PAGES.PROFIL.@GENERAL_INFORMATION')" icon="icon-f-home" />

        <div class="read-only-input">
          <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_NAME") }}</label>
          <p>{{ internalProfile[IEtabProfile.etabName] }}</p>
        </div>

        <div class="read-only-input">
          <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_ADDRESS") }}</label>
          <p>{{ internalProfile[IEtabProfile.address] }}</p>
        </div>

        <div class="read-only-input">
          <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_POSTAL_CODE") }}</label>
          <p>{{ internalProfile[IEtabProfile.postalCode] }}</p>
        </div>

        <div class="read-only-input">
          <label>{{ $t("ETAB.FORMS.LABELS.@ETAB_CITY") }}</label>
          <p>{{ internalProfile[IEtabProfile.city] }}</p>
        </div>
        <Field
          v-slot="{ errors, field, value }"
          v-model.number="internalProfile[IEtabProfile.seats]"
          as="div"
          :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@COUVERT_NUMBER'))"
          :rules="{ numeric: true }"
        >
          <QInput
            v-bind="field"
            :model-value="value"
            :name="IEtabProfile.seats"
            type="number"
            :label="$t('ETAB.FORMS.LABELS.@COUVERT_NUMBER') + $t('ETAB.FORMS.LABELS.@OPTIONAL')"
            :error="errors.length > 0"
            :error-message="errors[0]"
          />
        </Field>

        <Field
          v-slot="{ errors, field, value }"
          v-model.trim="internalProfile[IEtabProfile.description]"
          as="div"
          :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@DESCRIPTION'))"
          :rules="{ max: XLONG_TEXT_LENGTH_LIMIT }"
        >
          <QInput
            v-bind="field"
            :model-value="value"
            type="textarea"
            :error="errors.length > 0"
            :error-message="errors[0]"
            :maxlength="XLONG_TEXT_LENGTH_LIMIT"
            :name="IEtabProfile.description"
            counter
            :label="$t('ETAB.FORMS.LABELS.@DESCRIPTION') + $t('ETAB.FORMS.LABELS.@OPTIONAL')"
            @blur="$forceUpdate()"
          />
        </Field>

        <QInput
          v-model="internalProfile[IEtabProfile.website]"
          :name="IEtabProfile.website"
          type="url"
          :label="$t('ETAB.FORMS.LABELS.@WEB_SITE') + $t('ETAB.FORMS.LABELS.@OPTIONAL')"
        />

        <QInput
          v-model="internalProfile[IEtabProfile.facebook]"
          :name="IEtabProfile.facebook"
          type="url"
          :label="$t('ETAB.FORMS.LABELS.@FACEBOOK_PAGE') + $t('ETAB.FORMS.LABELS.@OPTIONAL')"
        />
      </section>

      <QFooter class="bg-transparent footer-padding">
        <div>
          <QBtn
            type="submit"
            color="secondary"
            class="full-width btn-navigation semi-transparent-bottom-shadow"
            :label="$t('ETAB.BUTTONS.@SAVE_QUIT')"
            no-caps
          />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>
<script>
  import { Form as VeeForm, Field } from "vee-validate";
  import { EtabProfileModel, IEtabProfile } from "@core/models";
  import { XLONG_TEXT_LENGTH_LIMIT } from "@core/constants";

  export default {
    components: {
      VeeForm,
      Field,
    },
    props: {
      profile: {
        type: Object,
        default: () => new EtabProfileModel(),
      },
    },
    emits: ["onSaveQuit"],
    data() {
      return {
        internalProfile: new EtabProfileModel(),
      };
    },
    created() {
      this.XLONG_TEXT_LENGTH_LIMIT = XLONG_TEXT_LENGTH_LIMIT;
      this.IEtabProfile = IEtabProfile;
    },
    mounted() {
      this.internalProfile = new EtabProfileModel(this.profile);
    },
    methods: {
      async onSaveQuit() {
        const valid = await this.$refs.form.validate();
        if (valid) {
          this.$emit("onSaveQuit", { profile: this.internalProfile });
        }
      },
    },
  };
</script>

<style lang="scss">
  .profile-component {
    $space_for_validation: 16px;

    > form > section {
      padding: 15px;

      .q-input {
        margin-top: $space_for_validation;
      }

      .read-only-input {
        margin-top: $space_for_validation;
        label {
          font-weight: bold;
        }
      }
    }
  }
</style>
